import { BUNNY_PLAYBACK_URL_PREFIX, MUX_PLAYBACK_URL_PREFIX } from "@/config/constants";
import { Video } from "@/prisma/generated/client";

export function getVideoUrl(video: Video) {
  switch (video.platform) {
    case "Bunny":
      return `${BUNNY_PLAYBACK_URL_PREFIX}/${video.bunnyVideoGuid}/playlist.m3u8`;
    case "Mux":
      return `${MUX_PLAYBACK_URL_PREFIX}/${video.muxPlaybackId}.m3u8`;
    case "YouTube":
    case "Other":
    default:
      return video.externalVideoId || "";
  }
}

export function getVideoPlaybackId(videoUrl: string) {
  if (videoUrl.startsWith(BUNNY_PLAYBACK_URL_PREFIX)) {
    const videoGuid = videoUrl.replace("/playlist.m3u8", "").split("/").pop();

    return videoGuid;
  } else if (videoUrl.startsWith(MUX_PLAYBACK_URL_PREFIX)) {
    const muxPlaybackId = videoUrl.replace(".m3u8", "").split("/").pop();

    return muxPlaybackId;
  }
}
